import {useEffect} from 'react';
import serviceConfig from 'config';
import FeatureToggleUtils from 'FeatureToggleUtils';
import {ConsentCategory, onCategoryAllowed} from './consentHelper';

const refinerSurveyWaitTime = Number(serviceConfig.refinerSurveyWaitTime) || 1200000; // default 20 minutes

const useRefinerSurvey = ({id, email, name, surveyId}) => {
    useEffect(() => {
        if (!FeatureToggleUtils.isFeatureEnabled('showRefinerSurvey')) {
            return undefined;
        }

        let timeoutId;
        let cancelled = false;

        const removeListener = onCategoryAllowed(ConsentCategory.Functional, async() => {
            // Import refiner-js lazily: its module-level side effect injects
            // https://js.refiner.io/v001/client.js, so it must not be evaluated until
            // Functional (C0003) consent is granted. A static import would load the
            // Refiner client regardless of consent (see refiner-js >= 1.1.5).
            const {default: Refiner} = await import('refiner-js');
            if (cancelled) {
                return;
            }
            Refiner('setProject', serviceConfig.refinerProjectId);
            Refiner('identifyUser', {id, email, name});
            timeoutId = setTimeout(() => Refiner('showForm', surveyId), refinerSurveyWaitTime);
        });

        return () => {
            cancelled = true;
            removeListener();
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
        // Initialize the survey once on mount; the identity args are captured intentionally.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

export default useRefinerSurvey;
